var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("register-alianza", {
        ref: "register",
        on: { refresh: _vm.refreshConfigs },
      }),
      _c("show-alianzas", {
        ref: "table",
        on: { stores: _vm.openStores, editar: _vm.editarConfiguracion },
      }),
      _c("show-alianza-stores", {
        attrs: { config: _vm.selectedConfig },
        model: {
          value: _vm.dialogStores,
          callback: function ($$v) {
            _vm.dialogStores = $$v
          },
          expression: "dialogStores",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }